import React from "react";
import { Field, ErrorMessage } from "formik";
import { Link } from "react-router-dom";

import styles from "./CheckboxInput.module.scss";
import { CheckboxInputPropsType } from "./types";

export const CheckboxInput: React.FC<CheckboxInputPropsType> = ({
  name,
  label,
  links,
  id,
}) => {
  const checkboxId = id || name;

  const renderLabel = () => {
    if (typeof label === "string") {
      if (!links || links.length === 0) {
        return label;
      }

      const parts: React.ReactNode[] = [];
      let currentIndex = 0;
      let labelText = label;

      links.forEach((link, index) => {
        const linkIndex = labelText.indexOf(link.text, currentIndex);
        
        if (linkIndex !== -1) {
          if (linkIndex > currentIndex) {
            parts.push(labelText.slice(currentIndex, linkIndex));
          }
          
          parts.push(
            <Link key={`link-${index}`} to={link.to}>
              {link.text}
            </Link>
          );
          
          currentIndex = linkIndex + link.text.length;
        }
      });

      if (currentIndex < labelText.length) {
        parts.push(labelText.slice(currentIndex));
      }

      return parts.length > 0 ? parts : label;
    } else {
      return label;
    }
  };

  return (
    <div className={styles.checkboxItem}>
      <Field
        type="checkbox"
        className={styles.checkbox}
        id={checkboxId}
        name={name}
      />
      <label htmlFor={checkboxId} className={styles.checkboxLabel}>
        <span className={styles.checkboxLabelText}>{renderLabel()}</span>
      </label>
    </div>
  );
};

